import Vue from 'vue'

export const store = new Vue({
  data: {
    appStyle: {
      background: '#c0ffee'
    }
  }
})



// WEBPACK FOOTER //
// ./src/store.js